module.exports = __webpack_public_path__ + "img/2.7b49b7e6.png";